module.exports = __webpack_public_path__ + "static/img/portic_logo_300dpi.f2719a2.png";


//////////////////
// WEBPACK FOOTER
// ./src-detail/img/portic_logo_300dpi.png
// module id = nnTG
// module chunks = 1